<template>
	<div>
		<h3>{{ $t('designCatalogue') }}</h3>
		<input 
			v-model="featured" 
			@change="toggleCatalogueStyle" 
			type="checkbox" 
			class="toggle" 
			id="toggle" />
		<label for="toggle">
			<span class="on">{{ $t('featured') }}</span>
			<span class="off">{{ $t('simple') }}</span>
		</label>
	</div>
</template>

<script>
export default {
	data() {
		return {
			featured: false
    	}
	},
    methods:{
        toggleCatalogueStyle() {
			this.$emit('change-toggle', this.featured)
        }
    }
}
</script>

<style lang="scss" scoped>

input[type="checkbox"] {
  
  &.toggle {
    
    opacity: 0;
    position: absolute;
    left: -99999px;

    & + label {
      
      height: 40px;
      line-height: 40px;
      background-color: #ccc;
      padding: 0px 16px;
      border-radius: 16px;
      display: inline-block;
      position: relative;
      cursor: pointer;
      transition: all .25s ease-in;
      box-shadow: inset 0px 0px 2px rgba(0,0,0, .5);
      
      &:before, &:hover:before {
        
        content: ' ';
        position: absolute;
        top: 2px;
        left: 2px;
        width: 46px;
        height: 36px;
        background: #fff;
        z-index: 2;
		transition: all .25s ease-in;
        border-radius: 14px;
        
      }
      
      .off, .on {
        color: #fff;
      }
      
      .off {
        margin-left: 46px;
        display:inline-block;
      }
      
      .on {
        display: none;
      }
      
    }

    &:checked + label {
      
      .off {
        display: none;
      }
      .on {
        margin-right: 46px;
        display:inline-block;
      }
      
    }

    &:checked + label, &:focus:checked + label {
      
      background-color: var(--primaryDark);
      
      &:before, &:hover:before {
        
        background-position: 0 0;
        top: 2px;
        left: 100%;
        margin-left:-48px;
        
      }
      
    }

  }
  
}
// Below is for display only
body {
  background: #f1f1f1;
  padding-top: 24px;
  text-align:center;
  font-family: arial;
}
p {
  &:first-of-type {
    margin-top:24px;
  }
  font-size: 16px;
  color: #717171;
  margin:0; 
}
</style>